export default __webpack_public_path__ + "static/media/publish-live.25bc517a.gif";